import { isDevMode } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular';
import dayjs from 'dayjs';

import { bootstrapWithLocale } from '@go-suite/i18n-bootstrap';

import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl.js';
import 'dayjs/locale/tr.js';
import 'dayjs/locale/pl.js';

Sentry.init({
    dsn: 'https://26af612b7ff6a275d7b7553cf052b963@logger.go-suite.rocks/4',
    integrations: [
        Sentry.browserProfilingIntegration(),
        Sentry.browserApiErrorsIntegration(),
        Sentry.breadcrumbsIntegration(),
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['/api'],

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 1.0,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    enabled: true,
});

bootstrapWithLocale({
    onLocaleResolved: language => dayjs.locale(language),
    load: async () => ({
        component: (await import('./app/app.component')).AppComponent,
        config: (await import('./app/app.config')).appConfig,
    }),
})
    .then(applicationRef => {
        if (isDevMode()) {
            enableDebugTools(applicationRef.components[0]);
        }
    })
    .catch(err => console.error(err));
